import PropTypes from 'prop-types';

const Tags = ({ dataTestId = 'tag', label, prefixIcon, backgroundColor, fontColor, tagClassName }) => {
	return (
		<div
			className={`DS__tag-box ${tagClassName || ''}`}
			style={{ backgroundColor, color:fontColor }}
			data-testid={dataTestId}
	 	  >
			{prefixIcon && <div className="DS__tag-prefixIcon" data-testid='tag-icon'>{prefixIcon}</div>}
			<div className="DS__tag-label">{label}</div>
		</div>
	);
};

Tags.propTypes = {
	dataTestId: PropTypes.string,
	label: PropTypes.string.isRequired,
	prefixIcon: PropTypes.node,
	backgroundColor: PropTypes.string,
	fontColor: PropTypes.string,
	tagClassName: PropTypes.string
};

export default Tags;



